import CssBaseline from '@mui/material/CssBaseline';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { ReactNode } from 'react';
import { RiotTheme } from './riot-theme';

export default function RiotThemeProvider({
    children,
}: {
    children: ReactNode;
}) {
    return (
        <ThemeProvider theme={RiotTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}
